import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import s from './RangeSlider.scss';
const RangeSlider = (_param)=>{
    var { value, displayValue = value } = _param, rest = _object_without_properties(_param, [
        "value",
        "displayValue"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['slider-and-percent']
    }, /*#__PURE__*/ React.createElement("input", _object_spread({
        className: c(s['slider'], s['dreamup-branding']),
        type: "range",
        value: value
    }, rest)), /*#__PURE__*/ React.createElement("div", {
        "aria-hidden": true,
        className: s['percent']
    }, displayValue));
};
RangeSlider.displayName = 'RangeSlider';
export default RangeSlider;

//# sourceMappingURL=RangeSlider.js.map